<template>
  <div id="app"> 
     <component :is="layout">
        <router-view :layout.sync="layout"/>
    </component>  
<b-modal id="modal-sm" v-if="IsAuth"  size="md" title="Void Claims" v-model="isIdle"
 no-close-on-esc no-close-on-backdrop hide-header-close hide-header hide-footer> 
<div slot="default"> 
    <div class='alert alert-success' role='alert'> <ModalIdle v-if="isIdle" /> </div>
</div>  
</b-modal>

<!-- <b-modal id="loadingmodel" size="md" v-model="loading" no-close-on-esc no-close-on-backdrop hide-header-close hide-footer>
        <div slot="default">
        <div class='alert alert-danger' role='alert'> We are processing your request, please wait.... <br>  </div>
       <div class="text-center justify-content-center row col-12">
            <ring-loader class="text-center justify-content-center" :color="color" :loading="loading" :size="Ringsize" :sizeUnit="unit"></ring-loader> 
            <rise-loader class="text-center justify-content-center" :color="color" :loading="loading" :size="Risesize" :sizeUnit="unit"></rise-loader> 
            <ring-loader class="text-center justify-content-center" :color="color" :loading="loading" :size="Ringsize" :sizeUnit="unit"></ring-loader> 
        </div>          
        </div>  
</b-modal> -->


</div>
</template>
<script>
import ModalIdle from "@/Common/SessionModal";
import { RingLoader } from '@saeris/vue-spinners';
import { RiseLoader } from '@saeris/vue-spinners';
export default {
  name: 'app',
  props : 
          {
            
        } ,
  data () {
    return {
       layout: 'div',
        isToggled: false,
        //loading: false,
        // size: 250,
        // Ringsize: 40,
        // Risesize: 12,
        // margin :'2px',
        // unit: 'px',
        // color:'#bada55',
     } 
  }, 
   computed: {
    // loading(){
    //   //console.log(this.$store.state.ShowLoading)
    //       return this.$store.state.ShowLoading;
    //     },
     		isIdle() {
          return this.$store.state.idleVue.isIdle;
        },
        GetMainMenu () { 
            if(this.$store.getters.IsAuth)
            return this.$store.getters.GetMainMenu;
        },
         IsAuth () {  
             //alert(this.$store.getters.IsAuth)
             return this.$store.getters.IsAuth;
          },
          BuildMenu () {  
             //alert(this.$store.getters.IsAuth)
             return this.$store.getters.GetuildMainMenu;
          },
    },
     watch: { 
      loading:  function()
      {
        return this.$store.state.ShowLoading;
      },
      IsAuth : function(val)
      {
        //alert(this.$store.getters.isAuth)
        return this.$store.getters.IsAuth;
      }, 
    },
    created (){
     this.$store.dispatch('AutoLogin');
    },
      mounted: function () {
    //   let recaptchaScript = document.createElement('script')
    //     recaptchaScript.setAttribute('src', 'http://w2ui.com/src/w2ui-1.5.rc1.min.js')
    //      document.head.appendChild(recaptchaScript)
    },
  components: {
   ModalIdle,
   RingLoader,
   RiseLoader, 
  },
  methods: {
     closeMenu(val) {
    this.isToggled = val;
  }
  },
  //  mounted() {
  //   this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
  //     //console.log('Modal is about to be shown', bvEvent, modalId)
  //   })
  //}
}
</script> 
<style scoped>
.modalHeader {
  color: black;
  background-color: #00558C;
  text-align: center;
  font-weight: 600;
}
.info {
  background-color: #00558C;
}  
</style>